import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { EnumHelper, TaskDataRowDataType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IReportParameterValue, ReportParameterValue } from "../report/reportParameterValue";

export interface IChartItem extends IIdTitle {
    id: string;
    reportName: string;
    reportDescription: string;
    chartNames: string[];
    taskType: ITaskEditTypeItem; //customer parameters schema
    taskDataRow: ITaskDataRow; //customer parameter values
}

export class ChartItem extends IdTitle implements IChartItem {
    id: string;
    reportName: string;
    reportDescription: string;
    chartNames: string[];
    taskType: TaskEditTypeItem; //customer parameters schema
    taskDataRow: TaskDataRow; //customer parameter values

    constructor();
    constructor(obj: IChartItem);
    constructor(obj?: any) {
        super(obj);
        this.id = obj && obj.id || "";
        this.reportName = obj && obj.reportName || "";
        this.reportDescription = obj && obj.reportDescription || "";
        this.chartNames = obj && obj.chartNames || [];
        this.taskType = null;
        if (obj && obj.taskType) {
            this.taskType = new TaskEditTypeItem(obj.taskType);
        }
        this.taskDataRow = null;
        if (this.taskType) {
            if (!obj.taskDataRow) {
                this.taskDataRow = new TaskDataRow();
                this.taskDataRow.id = Base.getGuid();
                this.taskDataRow.initializeToTaskType(this.taskType);
            } else {
                this.taskDataRow = new TaskDataRow(obj.taskDataRow);
                this.taskDataRow.initializeCols(this.taskType);
            }
        }
    }

    getHash(): string {
        return super.getHash() + "#" + this.id + "#" + this.reportName + "#" + Base.joinSuffix(this.chartNames, "#") + (this.taskDataRow ? this.taskDataRow.getHash() : "");
    }
    
    getReportParameterValues(): IReportParameterValue[] {
        if (!this.taskType || !this.taskDataRow) return [];
        const result: IReportParameterValue[] = [];
        for (const col of this.taskDataRow.cols) {
            const typeCol = this.taskType.formCols.find(i => i.field === col.field);
            if (!typeCol) continue;
            let value = this.taskDataRow.getTaskDataRowColUiValue(col.field, this.taskType);
            if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.StringArray) || EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TreeStringArray)) {
                const array: string[] = value ? JSON.parse(value) : [];
                value = JSON.stringify(array.filter(i => !!i));
            }
            result.push(ReportParameterValue.createReportParameterValue(col.field, value));
        }
        return result;
    }

    static sortChartItems(items: IChartItem[]): IChartItem[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IChartItem, b: IChartItem) => {
            if (!a || !b) return 0;
            return Base.strCompare(a.title, b.title);
        });
    }
}